import { TableColumnMeta } from "ds/components/Table/types";

export enum ActionsColumnId {
  ACTIONS = "actions",
}

export const CUSTOM_END_COLUMN_CONFIG: Record<ActionsColumnId, TableColumnMeta> = {
  [ActionsColumnId.ACTIONS]: {
    id: ActionsColumnId.ACTIONS,
    title: "Actions",
    noHeader: true,
    maxWidth: 40,
    minWidth: 40,
    defaultWidth: 40,
    resizable: false,
  },
};
